import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/users";

export async function saveUser(user) {
  const data = {
    username: user.username,
    password: user.password,
    firstName: user.firstName,
    lastName: user.lastName,
    facebook_url: user.facebook_url,
    role: user.role,
  };
  console.info(data);
  await http.put(`${apiEndpoint}/${user.id}`, data);
}

export function register(user) {
  return http.post(`${apiEndpoint}/register`, {
    username: user.username,
    password: user.password,
    firstName: user.firstName,
    lastName: user.lastName,
    facebook_url: "",
    role: user.role,
  });
}
